import { ErrorHandler, Injectable } from '@angular/core';
import { MonitoringService } from '@common/services/monitoring.service';
import { environment } from '../../environments/environment';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(private monitoringService: MonitoringService) {
        super();
    }

    handleError(error: Error) {
        if (!environment.production) {
            console.error(error);
        }

        this.monitoringService.logException(error);
    }
}
